// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-section-select-component {\n  width: 250px;\n}\n.upload-section-content {\n  background-color: #f5f6f8;\n  display: flex;\n  flex-direction: column-reverse;\n  height: 35vh;\n  margin-top: 20px;\n  padding: 20px;\n  width: 100%;\n}\n.upload-section-uploader-container {\n  justify-self: flex-start;\n}\n", ""]);
// Exports
module.exports = exports;
